import React from "react";
import Navigation from "../components/Navigation";
import HeroSection from "../components/HeroSection";
import BentoFeaturesSection from "../components/BentoFeaturesSection";
import HowItWorksSection from "../components/HowItWorksSection";
import DevicesSection from "../components/DevicesSection";
import TechnicalSpecsSection from "../components/TechnicalSpecsSection";
import MediaShowcaseSection from "../components/MediaShowcaseSection";
import FooterSection from "../components/FooterSection";

import "../styles/global.css";

const HealthcareLanding = () => {
  return (
    <div className="app-root">
      <Navigation />
      <main>
        <HeroSection />
        <BentoFeaturesSection />
        <MediaShowcaseSection />
        <HowItWorksSection />
        <DevicesSection />
        <TechnicalSpecsSection />

      </main>
      <FooterSection />
    </div>
  );
};

export default HealthcareLanding;
